import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: 0,
  name: '',
  hid: '',
  photo: '',
  permissions: '',
  exhibitDiver: 0,
  status: 0,
  is24h: false,
  expirations: {},
  orgs: [],
  admin: false
};

export const userSlice = createSlice({
  name: 'localUser',
  initialState,
  reducers: {
    setLocalId: (state, action) => {
      state.id = action.payload;
    },
    setLocalName: (state, action) => {
      state.name = action.payload;
    },
    setLocalHid: (state, action) => {
      state.hid = action.payload;
    },
    setLocalPhoto: (state, action) => {
      state.photo = action.payload;
    },
    setLocalPermissions: (state, action) => {
      state.permissions =  action.payload;
    },
    setLocalExhibitDiver: (state, action) => {
      state.exhibitDiver =  action.payload;
    },
    setLocalIs24h: (state, action) => {
      state.is24h =  action.payload;
    },
    setLocalExpirations: (state, action) => {
      state.expirations =  action.payload;
    },
    setLocalOrgs: (state, action) => {
      state.orgs =  action.payload;
    },
    setLocalStatus: (state, action) => {
      state.status =  action.payload;
    },
    setLocalAdmin: (state, action) => {
      state.status =  action.payload;
    },
    setLocalUser: (state, action) => action.payload,
    clearLocalUser: () => initialState
  },
})

// Action creators are generated for each case reducer function
export const { setLocalId, setLocalName, setLocalHid, setLocalPhoto, setLocalExhibitDiver, setLocalPermissions, setLocalIs24h, setLocalExpirations, setLocalOrgs, setLocalStatus, setLocalAdmin, setLocalUser, clearLocalUser } = userSlice.actions;

export default userSlice.reducer